import { Controller } from '@hotwired/stimulus';
import BootstrapSelect from '../select/bootstrap-select'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    connect() {
        this.element.addEventListener('change', event => {
            const hidden = document.getElementById('sort')
            if (hidden) {
                hidden.value = event.target.value;
                
                // @adobe-tracking
                try {
                    document.getElementById('f').value = 's'
                } catch (err) {}
                
                hidden.form.dispatchEvent(new Event('submit', { cancelable: true }))
            }
        })

        var select = new BootstrapSelect(this.element, { mobile: IBE.isMobile })
    }
}